import styled from "styled-components";

export const Container = styled.div`
  min-width: 500px;
  display: flex;
  flex-direction: column;
  padding: 15px;
`;

export const LabelButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 5px;
`;

export const LabelContainer = styled.div`
  display: flex;
  align-items: flex-end;
`;
